import { CLEAR } from './names';

export const clear = () => ({
  type: CLEAR,
});
